import { render, staticRenderFns } from "./SemiologiaOftalmologica.vue?vue&type=template&id=6387194f"
import script from "./SemiologiaOftalmologica.vue?vue&type=script&lang=js"
export * from "./SemiologiaOftalmologica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports